import * as React from 'react';
import { PrimaryButton, DefaultButton, Link } from 'office-ui-fabric-react/lib/index';
import classnames from 'classnames'
import Wrapper, { DEFAULT_HELP_LINKS } from './Wrapper'
import { getVersion } from '../util';

export interface ProgressProps {
	error?: boolean;
	title: string;
	message: string;
	additional?: string;
	dismissButtonTitle?: string;
	onDismiss?: () => void;
	account?: any,
	autoLogin?: (any, string) => string,
	onSignout?: () => void,
	cancelButtonTitle?: string;
	continueButtonTitle?: string;
	onCancel?: () => void,
	onContinue?: () => void,
}

export default class Progress extends React.Component<ProgressProps> {
	render() {
		const {
			error,
			title,
			message,
			additional,
			dismissButtonTitle,
			cancelButtonTitle,
			continueButtonTitle,
			onCancel,
			onContinue,
			onDismiss,
			account,
			onSignout,
			autoLogin
		} = this.props;

		var finalMessage = message;

		var link = null;

		if (finalMessage.indexOf('##faq-multiplerecipients##')) {
			finalMessage = finalMessage.replace('##faq-multiplerecipients##', '');
			link = 'https://mm365.me/faq-multiplerecipients';
		}

		return (
			<Wrapper
				account={account}
				autoLogin={autoLogin}
				onSignout={onSignout}
				className={classnames("mm-view mm-message", { "-error": error })}>
				<p className="ms-font-xl -title">{title}</p>
				<p className="ms-font-m -message">{finalMessage}</p>


				{onDismiss &&
					<p className="-button">
						<PrimaryButton onClick={() => onDismiss()}>{dismissButtonTitle || 'OK'}</PrimaryButton>
					</p>}



				{(onCancel || onContinue) &&
					<p className="-button">
						{onCancel &&
							<PrimaryButton onClick={() => onCancel()}>{cancelButtonTitle || 'Cancel'}</PrimaryButton>
						}
						{onContinue &&
							<DefaultButton onClick={() => onContinue()} style={{ marginLeft: '10px' }}>{continueButtonTitle || 'Continue'}</DefaultButton>
						}
					</p>
				}

				<small style={{ display: "block", paddingTop: "5px", paddingBottom: "5px" }}>Version: {getVersion()}</small>

				{additional && <textarea style={{ fontSize: "10px", "width":"100%" }} rows={5}>{additional}</textarea>}

				{link && <div className="" style={{ marginTop: "25px" }}>
					<ul className="-links">
						<li key={'more-info'}><i className="ms-Icon ms-Icon--ChevronRight" aria-hidden="true"></i>
							<Link target="_blank" href={link}>More information in our FAQ</Link></li>
					</ul>
				</div>}

			</Wrapper>
		);
	}
}
